import React from "react";
import { TextView } from "../Text";
import { ButtonActionType, ButtonDesignSize } from "../../../shared/types";
const ButtonView = ({
  element,
  elementContentRef,
  wuiltContext,
  stopAction,
  isDisabled,
  text
}) => {
  const buttonSettings = element?.settings;
  const buttonActionType = buttonSettings?.action?.type;
  const shouldButtonFill = buttonSettings?.design?.size == ButtonDesignSize.Fill;
  const shouldOpenInANewTab = buttonSettings?.action?.shouldOpenInANewTab;
  const base = wuiltContext?.base;
  const Link = base?.Link;
  const PageLink = base?.PageLink;
  const Component = stopAction || buttonActionType === ButtonActionType.Button || buttonActionType === ButtonActionType.Submit ? "button" : buttonActionType === ButtonActionType.InternalLink ? PageLink : Link;
  const {
    page,
    href,
    type
  } = getLinkProps(buttonSettings?.action);
  const buttonGlobalStyleType = buttonSettings?.design?.style?.toLowerCase();
  if (!Component) return null;
  return /*#__PURE__*/React.createElement(Component, {
    id: element?.id,
    disabled: isDisabled,
    "data-test": "ButtonView",
    className: `button-view-${buttonGlobalStyleType}`,
    style: {
      display: "flex",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      whiteSpace: "nowrap",
      width: shouldButtonFill ? "100%" : undefined,
      height: shouldButtonFill ? "100%" : undefined
    },
    page: stopAction ? undefined : page,
    href: stopAction ? undefined : href,
    target: shouldOpenInANewTab ? "_blank" : undefined,
    type: type
  }, /*#__PURE__*/React.createElement(TextView, {
    text: text,
    element: element,
    elementContentRef: elementContentRef
  }));
};
export { ButtonView };

/**
 * Helpers
 */

function getLinkProps(action) {
  if (action?.type === ButtonActionType.ExternalLink) {
    const href = action?.value;
    return {
      href
    };
  }
  if (action?.type === ButtonActionType.Phone) {
    const href = `tel:${action?.value}`;
    return {
      href
    };
  }
  if (action?.type === ButtonActionType.Email) {
    const href = `mailto:${action?.value}?subject=${action?.emailSubject || ""}`;
    return {
      href
    };
  }
  if (action?.type === ButtonActionType.Button) {
    return {
      type: "button"
    };
  }
  if (action?.type === ButtonActionType.Submit) {
    return {
      type: "submit"
    };
  }

  // if ButtonActionType.Internal_Page or else
  const page = {
    id: action?.value
  };
  return {
    page,
    href: "#"
  };
}
//# sourceMappingURL=ButtonView.js.map